import { c as _c } from "react/compiler-runtime";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { TEAMS_DISPLAY_NAME } from "@constants/team-constants";
import { useAppSelector } from "@store/store-helper";
import { memberTeamsStatusSelector } from "@store/teams/teams-selector";
/**
 * Shows the KPI bar with the total number of teams the member belongs to.
 */
export function MemberTeamsDetails(t0) {
  const $ = _c(3);
  const {
    teamsCount
  } = t0;
  const status = useAppSelector(memberTeamsStatusSelector);
  if (status === "pending" || status === "uninitialized") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <InfoBar isLoading={true} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== teamsCount) {
    t1 = <InfoBar items={[{
      label: `Total ${TEAMS_DISPLAY_NAME}`,
      content: teamsCount
    }]} />;
    $[1] = teamsCount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}